import React, { useState } from "react";
import { Stack, Text, Flex } from "@mantine/core";
import BasicButton from "@/UI/BasicButton";
import { Checkbox } from "@/shared/ui/checkbox";
import { setDataToStorage } from "@/Utils/localStorageHelpers";
import modalStyles from "@/Theme/modalsElements.module.scss";
import styles from "./delay-attention-modal.module.scss";

interface DelayAttentionModalProps {
  onClose: () => void;
}

export const DelayAttentionModal: React.FC<DelayAttentionModalProps> = ({
  onClose,
}) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleSubmit = () => {
    if (dontShowAgain) {
      setDataToStorage("disable_delay_modal", dontShowAgain);
    }

    onClose();
  };

  return (
    <Stack
      className={`${modalStyles.modal_wrapper} ${styles.delay_modal_wrapper}`}
      gap={32}
      align="center"
    >
      <h3 className={`${modalStyles.modal_title} ${styles.delay_modal_title}`}>
        Delayed start
      </h3>
      <Text className={styles.delay_modal_text} ta="center" size="md">
        The campaign will be launched in all the countries specified in the
        order at the same time, according to the time provided by you in your
        time zone.
      </Text>
      <Flex align="center" gap={12} className={styles.delay_checkbox_label}>
        <Checkbox
          name="dont-show"
          checked={dontShowAgain}
          onChange={(event) => setDontShowAgain(event.target.checked)}
        />
        <Text className={styles.delay_checkbox_text}>Don't show it again</Text>
      </Flex>
      <div className={styles.delay_button_block}>
        <BasicButton
          onClick={handleSubmit}
          size="lg"
          text="OK"
          variant="blue"
        />
      </div>
    </Stack>
  );
};
